import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            分类浏览
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            丰富的视频分类，总有一类适合你的口味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-200 hover:bg-primary-50/40 transition-all duration-300 cursor-pointer"
            >
              <span className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </span>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-400 mb-2 line-clamp-2">
                {cat.description}
              </p>
              <span className="text-xs text-primary-500 font-medium">
                {cat.videoCount} 部视频
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}